"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _InterestSettingsComponent = _interopRequireDefault(require("./InterestSettingsComponent"));
var _interestAccountActions = require("../../../redux/actions/interestAccountActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var accountStatus = state.interestBearingAccounts.accountStatus;
  return {
    accountStatus: accountStatus,
    selectedAccountId: state.user.selectedAccountId
  };
};
var mapDispatchToProps = {
  getInterestAccountStatus: _interestAccountActions.getInterestAccountStatus
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_InterestSettingsComponent["default"]);